function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M.4 1.3v509.5h826V1.3H.4"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fccb01",
  d: "M809.2 493.6H17.6V18.5h791.6v475.1"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#174385",
  d: "M187.3 332.6c13.2 0 20.9 9.4 20.9 20.7 0 11.6-7.7 20.5-20.9 20.5s-20.9-9-20.9-20.5a20 20 0 0 1 21-20.7zm-19.8-25.2H135v137.3h32.5v-54.5c7 8 17.8 11.8 28.4 11.8 27.1 0 45.8-22.1 45.8-48.5 0-26.3-18.9-49.1-46.2-49.1-10.7 0-21.8 4.3-27.6 13.4h-.4v-10.4M299.2 322.4h.3c6.3-11.2 17-16.2 29.7-16.2h6.2v31.2c-4.5-2.5-8.7-3-13.7-3-18 0-22.5 12-22.5 27.6v37h-32.5v-91.6h32.5v15M389 399h-32.5v-91.6h32.4zm1.9-126.7c0 10-8.2 18.2-18.2 18.2s-18.2-8.3-18.2-18.2c0-10 8.2-18.3 18.2-18.3s18.2 8.2 18.2 18.3M414.4 307.4h41.3l16.4 19 16.4-19h42l-37.9 42 45.7 49.6h-42.7l-23.5-27.1-23.6 27H406l45.7-49.5-37.2-42"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#174385",
  d: "M620 113.4c-38.9 0-69.6 17.5-77.7 48.6-8-31-38.8-48.6-77.6-48.6-35.2 0-64 14.5-74.9 40.4-11-26-39.6-40.4-74.9-40.4-45.2 0-79.6 23.9-79.6 65.3 0 10.4 2.2 19.6 6.2 27.7l-1.6.8a72 72 0 0 1-27 5c-20.6 0-39-13-39-32.8 0-21.6 15.8-34.5 36.3-34.5 6.3 0 11.8.7 16.9 2.1 0 0 5.4-14.4 18.7-25.2l-3.9-1.7a92.4 92.4 0 0 0-37.2-6.7c-45.3 0-79.7 23.9-79.7 65.3 0 41 34.4 65 79.7 65 12 0 25.2-1.7 36.6-5A98 98 0 0 0 263 230a95.4 95.4 0 0 0 52 13.7c35.2 0 63.9-14.5 74.8-40.4 11 25.9 39.7 40.4 75 40.4 36 0 65-15.2 75.5-42.1v75.3h48.6v-37.4c9.5 2.7 20 4.2 31 4.2 45.3 0 79.7-24 79.7-65 0-41.4-34.4-65.3-79.6-65.3zM315 213.6c-21.9 0-30.8-16.5-30.8-35 0-18.6 9-35.1 30.7-35.1 21.9 0 30.8 16.5 30.8 35.2 0 18.4-9 34.9-30.8 34.9zm149.7 0c-21.8 0-30.7-16.5-30.7-35 0-18.6 8.9-35.1 30.7-35.1 21.8 0 30.8 16.5 30.8 35.2 0 18.4-9 34.9-30.8 34.9zm155.3 0c-21.9 0-30.8-16.5-30.8-35 0-18.6 8.9-35.1 30.8-35.1 21.7 0 30.7 16.5 30.7 35.2 0 18.4-9 34.9-30.7 34.9"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    shaperendering: "geometricPrecision",
    viewBox: "0 0 827 512"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/coop-prix.a68ad61d.svg";
export { SvgComponent as ReactComponent };